define('chatInboxView',[
  'module',
  'app',
  'marionette',
  'underscore',
  'chatInboxListView',
  'chatInboxDetailView'
], function (Module, App, Marionette, _, ListView, DetailView) {
  'use strict';

  // Email-style split layout for the chat inbox: the conversation list lives
  // permanently in the left pane, the selected conversation opens in the right
  // pane. The router drives selection (so deep links / back-button work), but
  // reuses a single instance of this view across chat-inbox/:secId navigations
  // — selectSession() only swaps the right pane, never rebuilding the left
  // list (which carries scroll position and a live WS-refreshed roster).
  Module.exports = Marionette.LayoutView.extend({
    className: 'chat-inbox-split-view',

    template: _.template(
      '<div class="ci-list-pane"></div>' +
      '<div class="ci-detail-pane"></div>'
    ),

    regions: {
      listPane: '.ci-list-pane',
      detailPane: '.ci-detail-pane'
    },

    initialize: function (options) {
      this.selectedSecId = (options && options.selectedSecId) || null;
    },

    onShow: function () {
      this.listView = new ListView();
      this.getRegion('listPane').show(this.listView);

      if (this.selectedSecId) {
        this.selectSession(this.selectedSecId);
      } else {
        this.showPlaceholder();
      }
    },

    // Open a conversation in the right pane and mark its row active. Called by
    // the router both on first show and on every subsequent chat-inbox/:secId
    // navigation, so the left list (and its live updates) survives intact.
    selectSession: function (secId) {
      this.selectedSecId = secId;
      if (this.listView) { this.listView.setSelected(secId); }
      this.getRegion('detailPane').show(new DetailView({ secId: secId }));
    },

    // Back to the empty state (route returned to plain chat-inbox).
    clearSelection: function () {
      this.selectedSecId = null;
      if (this.listView) { this.listView.setSelected(null); }
      this.showPlaceholder();
    },

    showPlaceholder: function () {
      // Drop any open detail view, then paint the empty state directly into the
      // pane (a later selectSession -> region.show() overwrites it cleanly).
      this.getRegion('detailPane').empty();
      this.$('.ci-detail-pane').html(
        '<div class="ci-empty">' +
        '  <div class="ci-empty-inner">' +
        '    <div class="ci-empty-icon">&#128172;</div>' +
        '    <div class="ci-empty-title">Select a conversation</div>' +
        '    <div class="ci-empty-sub">Pick a chat on the left to read it and reply.</div>' +
        '  </div>' +
        '</div>'
      );
    },

    onDestroy: function () {
      this.listView = null;
    }
  });
});

